<mat-form-field class="width" [appearance]="appearance">

    <mat-label>Produkttyp wählen</mat-label>
    <mat-select [formControl]="formControl">

        <mat-option *ngFor="let type of ProductTypes" [value]="type">
            {{type}}
        </mat-option>

    </mat-select>

</mat-form-field>
